export default __webpack_public_path__ + "static/media/safe-travel.8de6889e.svg";